namespace Matrix.Rebalancer {
    export interface HoldingClassWeightRow {
        HoldingClassWeightId?: number;
        AccountCode?: string;
        SecurityId?: number;
        Weight?: number;
        ExposureCurrency?: string;
        Class1?: string;
        Class2?: string;
        Class3?: string;
        Class4?: string;
        Class5?: string;
        Class6?: string;
        Class7?: string;
        Class8?: string;
        Class9?: string;
        Class10?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountCodeName?: string;
        AccountCodeRowId?: number;
        AccountCodeAccountTypeCode?: string;
        AccountCodeAccountRoleCode?: string;
        AccountCodeManagerCode?: string;
        AccountCodeBaseCurrencyCode?: string;
        AccountCodeAssetClass?: string;
        AccountCodeBenchmark1?: string;
        AccountCodeBenchmark2?: string;
        AccountCodeInceptionDate?: string;
        AccountCodeTerminationDate?: string;
        AccountCodeInvestmentObjective?: string;
        AccountCodeDefaultSortOrder?: number;
        AccountCodePerformanceBenchmark1Code?: string;
        AccountCodePerformanceBenchmark2Code?: string;
        AccountCodePerformanceInceptionDate?: string;
        AccountCodePerformanceTerminationDate?: string;
        SecurityName?: string;
        SecurityRowId?: number;
        SecurityDealParentCode?: string;
        SecuritySecurityTypeCode?: string;
        SecurityLocalCurrencyCode?: string;
        SecurityExposureMultiplier?: number;
        SecurityAssociatedAccountCode?: string;
        SecuritySedol?: string;
        SecurityRIC?: string;
        SecurityIsin?: string;
        SecurityCusip?: string;
        SecurityFigi?: string;
        SecurityTicker?: string;
        SecurityInternalSecurityCode?: string;
        SecurityIssuer?: string;
        SecurityCouponRate?: number;
        SecurityMaturityDate?: string;
        SecuritySpLtRating?: string;
        SecuritySpStRating?: string;
        SecurityMoodysLtRating?: string;
        SecurityMoodysStRating?: string;
        SecurityFitchLtRating?: string;
        SecurityFitchStRating?: string;
        SecurityInternalLtRating?: string;
        SecurityInternalStRating?: string;
        SecurityCountryOfIssueCode?: string;
        SecurityCountryOfRiskCode?: string;
        SecurityCurrencyOfRiskCode?: string;
        SecurityTradeDate?: string;
        SecurityEffectiveDate?: string;
        SecurityBrokerCode?: string;
        SecurityStrategy?: string;
        SecurityOptionStyle?: string;
        SecurityExerciseStyle?: string;
        SecurityPutOrCall?: string;
        SecurityStrikePrice?: number;
        SecurityStrikeCurrency?: string;
        SecurityPremium?: number;
        SecurityPremiumCcy?: string;
        SecurityPayOrRec?: string;
        SecurityFixedOrFloat?: string;
        SecurityFloatIndex?: string;
        SecurityInflationIndexLag?: string;
        SecurityInterestTerm?: string;
        SecuritySpread?: number;
        SecurityAllIn?: number;
        SecurityInterestCcy?: string;
        SecurityPaymentFrequency?: string;
        SecurityPaymentBusDayConvention?: string;
        SecurityPaymentCalendar?: string;
        SecurityFirstPaymentDate?: string;
        SecurityDayCountBasis?: string;
        SecurityResetFrequency?: string;
        SecurityResetBusDayConvention?: string;
        SecurityResetCalendar?: string;
        SecurityUnderlyerName?: string;
        SecurityUnderlyerCcy?: string;
        SecurityUnderlyerType?: string;
        SecurityClearerReference?: string;
        SecurityRedCode?: string;
        SecurityCreditEvents?: string;
        SecurityGuarantor?: string;
        SecuritySecurityCode?: string;
        SecurityGicsSector?: number;
        SecurityGicsIndustryGroup?: number;
        SecurityGicsIndustry?: number;
        SecurityGicsSubIndustry?: number;
        ExposureCurrencyName?: string;
        ExposureCurrencyRowId?: number;
        ExposureCurrencyDefaultSortOrder?: number;
    }

    export namespace HoldingClassWeightRow {
        export const idProperty = 'HoldingClassWeightId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Rebalancer.HoldingClassWeight';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            HoldingClassWeightId = "HoldingClassWeightId",
            AccountCode = "AccountCode",
            SecurityId = "SecurityId",
            Weight = "Weight",
            ExposureCurrency = "ExposureCurrency",
            Class1 = "Class1",
            Class2 = "Class2",
            Class3 = "Class3",
            Class4 = "Class4",
            Class5 = "Class5",
            Class6 = "Class6",
            Class7 = "Class7",
            Class8 = "Class8",
            Class9 = "Class9",
            Class10 = "Class10",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountCodeName = "AccountCodeName",
            AccountCodeRowId = "AccountCodeRowId",
            AccountCodeAccountTypeCode = "AccountCodeAccountTypeCode",
            AccountCodeAccountRoleCode = "AccountCodeAccountRoleCode",
            AccountCodeManagerCode = "AccountCodeManagerCode",
            AccountCodeBaseCurrencyCode = "AccountCodeBaseCurrencyCode",
            AccountCodeAssetClass = "AccountCodeAssetClass",
            AccountCodeBenchmark1 = "AccountCodeBenchmark1",
            AccountCodeBenchmark2 = "AccountCodeBenchmark2",
            AccountCodeInceptionDate = "AccountCodeInceptionDate",
            AccountCodeTerminationDate = "AccountCodeTerminationDate",
            AccountCodeInvestmentObjective = "AccountCodeInvestmentObjective",
            AccountCodeDefaultSortOrder = "AccountCodeDefaultSortOrder",
            AccountCodePerformanceBenchmark1Code = "AccountCodePerformanceBenchmark1Code",
            AccountCodePerformanceBenchmark2Code = "AccountCodePerformanceBenchmark2Code",
            AccountCodePerformanceInceptionDate = "AccountCodePerformanceInceptionDate",
            AccountCodePerformanceTerminationDate = "AccountCodePerformanceTerminationDate",
            SecurityName = "SecurityName",
            SecurityRowId = "SecurityRowId",
            SecurityDealParentCode = "SecurityDealParentCode",
            SecuritySecurityTypeCode = "SecuritySecurityTypeCode",
            SecurityLocalCurrencyCode = "SecurityLocalCurrencyCode",
            SecurityExposureMultiplier = "SecurityExposureMultiplier",
            SecurityAssociatedAccountCode = "SecurityAssociatedAccountCode",
            SecuritySedol = "SecuritySedol",
            SecurityRIC = "SecurityRIC",
            SecurityIsin = "SecurityIsin",
            SecurityCusip = "SecurityCusip",
            SecurityFigi = "SecurityFigi",
            SecurityTicker = "SecurityTicker",
            SecurityInternalSecurityCode = "SecurityInternalSecurityCode",
            SecurityIssuer = "SecurityIssuer",
            SecurityCouponRate = "SecurityCouponRate",
            SecurityMaturityDate = "SecurityMaturityDate",
            SecuritySpLtRating = "SecuritySpLtRating",
            SecuritySpStRating = "SecuritySpStRating",
            SecurityMoodysLtRating = "SecurityMoodysLtRating",
            SecurityMoodysStRating = "SecurityMoodysStRating",
            SecurityFitchLtRating = "SecurityFitchLtRating",
            SecurityFitchStRating = "SecurityFitchStRating",
            SecurityInternalLtRating = "SecurityInternalLtRating",
            SecurityInternalStRating = "SecurityInternalStRating",
            SecurityCountryOfIssueCode = "SecurityCountryOfIssueCode",
            SecurityCountryOfRiskCode = "SecurityCountryOfRiskCode",
            SecurityCurrencyOfRiskCode = "SecurityCurrencyOfRiskCode",
            SecurityTradeDate = "SecurityTradeDate",
            SecurityEffectiveDate = "SecurityEffectiveDate",
            SecurityBrokerCode = "SecurityBrokerCode",
            SecurityStrategy = "SecurityStrategy",
            SecurityOptionStyle = "SecurityOptionStyle",
            SecurityExerciseStyle = "SecurityExerciseStyle",
            SecurityPutOrCall = "SecurityPutOrCall",
            SecurityStrikePrice = "SecurityStrikePrice",
            SecurityStrikeCurrency = "SecurityStrikeCurrency",
            SecurityPremium = "SecurityPremium",
            SecurityPremiumCcy = "SecurityPremiumCcy",
            SecurityPayOrRec = "SecurityPayOrRec",
            SecurityFixedOrFloat = "SecurityFixedOrFloat",
            SecurityFloatIndex = "SecurityFloatIndex",
            SecurityInflationIndexLag = "SecurityInflationIndexLag",
            SecurityInterestTerm = "SecurityInterestTerm",
            SecuritySpread = "SecuritySpread",
            SecurityAllIn = "SecurityAllIn",
            SecurityInterestCcy = "SecurityInterestCcy",
            SecurityPaymentFrequency = "SecurityPaymentFrequency",
            SecurityPaymentBusDayConvention = "SecurityPaymentBusDayConvention",
            SecurityPaymentCalendar = "SecurityPaymentCalendar",
            SecurityFirstPaymentDate = "SecurityFirstPaymentDate",
            SecurityDayCountBasis = "SecurityDayCountBasis",
            SecurityResetFrequency = "SecurityResetFrequency",
            SecurityResetBusDayConvention = "SecurityResetBusDayConvention",
            SecurityResetCalendar = "SecurityResetCalendar",
            SecurityUnderlyerName = "SecurityUnderlyerName",
            SecurityUnderlyerCcy = "SecurityUnderlyerCcy",
            SecurityUnderlyerType = "SecurityUnderlyerType",
            SecurityClearerReference = "SecurityClearerReference",
            SecurityRedCode = "SecurityRedCode",
            SecurityCreditEvents = "SecurityCreditEvents",
            SecurityGuarantor = "SecurityGuarantor",
            SecuritySecurityCode = "SecuritySecurityCode",
            SecurityGicsSector = "SecurityGicsSector",
            SecurityGicsIndustryGroup = "SecurityGicsIndustryGroup",
            SecurityGicsIndustry = "SecurityGicsIndustry",
            SecurityGicsSubIndustry = "SecurityGicsSubIndustry",
            ExposureCurrencyName = "ExposureCurrencyName",
            ExposureCurrencyRowId = "ExposureCurrencyRowId",
            ExposureCurrencyDefaultSortOrder = "ExposureCurrencyDefaultSortOrder"
        }
    }
}
